import { createAsyncThunk } from '@reduxjs/toolkit';
import { ThunkConfig } from 'src/thunks/index';
import Axios from 'src/libs/axios';
import notification from 'src/store/ui/notification';

export type AcceleratorPayload = {
  name?: string;
  email?: string;
  phone?: string;
  message?: string;
};

export const createContact = createAsyncThunk<
  void,
  AcceleratorPayload,
  ThunkConfig
>('create_accelerator_contact', async (args, { dispatch }) => {
  try {
    await new Axios().instance.post('contact', args);

    dispatch(
      notification.on({
        type: 'success',
        message:
          'Thank you for contacting us!, We will get in touch with you as soon as possible.',
      }),
    );
  } catch (err) {
    dispatch(
      notification.on({
        type: 'error',
        message: (err as any).response?.data?.message,
      }),
    );
  }
});
